/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-09 23:38:44
 */
 
import Api from "src/util/api";
import {PageDo, Result, ResultPageDo} from "src/types/base";
import { defaultNullValue } from 'src/config';
export declare namespace OperationLogDOI {

	export interface RowDataI {
		
	}

	export interface QueryRowDataParamsI extends PageDo {
		keyword?: string
	}

	export interface QueryDetailResultI {

	}

	export interface OperateParamsI {
		
	}

}
export default class OperationLogApi {
	/**
	 * 查询列表
	 * @param {OperationLogDOI.QueryRowDataParamsI} params
	 * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
	 */
	static async searchList(params: OperationLogDOI.QueryRowDataParamsI):Promise<ResultPageDo<OperationLogDOI.RowDataI[]>> {
		return Api.post('/monitor/select/running_log', {
            log_type: defaultNullValue,
            start_time: defaultNullValue,
            end_time: defaultNullValue,
            component: '',
            ...params
        })
    }
    
    static async searchSiteComponent(params: {mn: string}):Promise<Result<{key: string, name: string}[]>> {
		return Api.post('/monitor/select/site_component', params)
	}

    static async exportAll(params: OperationLogDOI.QueryRowDataParamsI):Promise<Result<{download_url: string}>> {
		return Api.post('/monitor/condition/running_log/export',{
            log_type: defaultNullValue,
            start_time: defaultNullValue,
            end_time: defaultNullValue,
            component: '',
            ...params
        })
    }
}